<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="EPRIJEMNICA.SINGULAR"></span></h2>
    <h1 class="modal-title">
      <span>Stavka</span>
    </h1>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <yt-eprijemnica-stavka-update #baseUpdate></yt-eprijemnica-stavka-update>
</div>
<!-- <div class="modal-footer">
  <button type="submit" class="btn btn-primary" (click)="Save()" [disabled]="saveDisabled"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" (click)="Close()"><span>Zatvori</span></button>
</div> -->